import React, { useEffect, useState } from 'react';
import { fetchReports } from '../api/reports';
import '../assets/css/DashboardReports.css';

const REPORTS_PER_PAGE = 5;

const DashboardReports = () => {
  const [reports, setReports] = useState([]);
  const [visibleReports, setVisibleReports] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const loadReports = async () => {
      try {
        const data = await fetchReports();
        setReports(data);
        setVisibleReports(data.slice(0, REPORTS_PER_PAGE));
      } catch (err) {
        setError(err.message || 'Failed to load reports');
      } finally {
        setLoading(false);
      }
    };

    loadReports();
  }, []);

  const totalPages = Math.ceil(reports.length / REPORTS_PER_PAGE);

  const handlePageChange = (newPage) => {
    if (newPage < 1 || newPage > totalPages) return;
    setCurrentPage(newPage);
    const start = (newPage - 1) * REPORTS_PER_PAGE;
    const end = start + REPORTS_PER_PAGE;
    setVisibleReports(reports.slice(start, end));
  };

  return (
    <div className="dashboard-reports">
      <div className="reports-header">
        <h2>Reported Posts</h2>
        <p>Review reports and take action if needed.</p>
      </div>

      {loading && <p className="status-msg">Loading reports...</p>}
      {error && <p className="status-msg error">{error}</p>}

      {!loading && !error && (
        <>
          <div className="reports-grid">
            {visibleReports.map((report) => (
              <div key={report.report_id} className="report-card">
                <div className="report-header">
                  <p><strong>Reporter:</strong> {report.reporter_name}</p>
                  <p><strong>Reported:</strong> {report.reported_name}</p>
                  <p><strong>Reason:</strong> {report.comments}</p>
                  <p><strong>Date:</strong> {new Date(report.report_date).toLocaleString()}</p>
                </div>

                {report.post_content && (
                  <p className="post-preview"><strong>Post:</strong> {report.post_content}</p>
                )}

                {report.media?.length > 0 && (
                  <div className="report-media-grid">
                    {report.media.map((m, i) => (
                      <div key={i} className="media-item">
                        {m.media_type === 'image' ? (
                          <img src={m.url} alt="media" />
                        ) : m.media_type === 'video' ? (
                          <video src={m.url} controls />
                        ) : (
                          <audio src={m.url} controls />
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>

          <div className="pagination">
            <button
              className="pagination-btn"
              disabled={currentPage === 1}
              onClick={() => handlePageChange(currentPage - 1)}
            >
              Previous
            </button>
            <span className="pagination-info">
              Page {currentPage} of {totalPages}
            </span>
            <button
              className="pagination-btn"
              disabled={currentPage === totalPages}
              onClick={() => handlePageChange(currentPage + 1)}
            >
              Next
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default DashboardReports;
